import EducationHistorySchema from 'schemas/history/educationHistory.schema'
import { z } from 'zod'

import { checkFieldOnDateValid } from 'utils/schema.util'

const cVStepEducationSchema = z.object({
  educationHistory: EducationHistorySchema.superRefine((value, ctx) =>
    checkFieldOnDateValid(value, ctx, true)
  ).array()
})

export default cVStepEducationSchema
